import React from 'react'
import verified from "../Images/Home_Page/ver.png"
import image from "../Images/Home_Page/card.png"
import search from "../Images/Home_Page/search.png"

function Main() {
  return (
    <main>
        <div className='container'>

          <div className='box-1'>
            <h2 className='first-text'>
              Professional
            </h2>
            <h1 className='second-text'>
              UI/UX
            </h1>
            <h3 className='third-text'>
              Designer
            </h3>
            <p className="forth-text">
              With Over 10years Experience
            </p>
            <img src={verified} alt="" className='ver--img' />
            <div className='profile-container'>
              <img src={image} alt="" className='profile-photo' />
              <div className='profile-stats'>
                <p className='name'>CEO</p>
                <h3 className='bold-name'>Prince Bernard</h3>
                <p className='name'>UI/UX Designer</p>
              </div>
            </div>
          </div>

          <div className="flyer-box">
            <form action="" className='search-bar'>
              <input className='input1' type="text" placeholder='Search' />
              <button className='btn'><img src={search} alt="" /></button>
            </form>
          </div>
        </div>
      </main>
  )
}

export default Main